module.exports = __webpack_public_path__ + "d8d8f9583d41feac2b1e0815acf13e8f.svg";